import axios from 'axios';

// Configuration de l'URL de base de l'API
// En production (Vercel), utiliser l'URL du backend O2Switch
// En développement, utiliser le proxy local
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Configurer l'URL de base
if (API_BASE_URL) {
  axios.defaults.baseURL = API_BASE_URL;
}

// Configuration globale pour ajouter automatiquement le token aux requêtes
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('6w2h_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // S'assurer que les credentials sont envoyés (cookies, auth headers)
    config.withCredentials = true;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs d'authentification
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Vérifier si c'est une vraie erreur d'authentification (token invalide/expiré)
    if (error.response?.status === 401 && 
        (error.response?.data?.code === 'TOKEN_EXPIRED' || 
         error.response?.data?.code === 'TOKEN_INVALID' ||
         error.response?.data?.code === 'NO_TOKEN')) {
      console.log('🔒 Session expirée, redirection vers login');
      localStorage.removeItem('6w2h_token');
      // Forcer un rechargement de la page pour déclencher le login
      window.location.reload();
    }
    // Pour les erreurs 403 (permissions insuffisantes), on ne déconnecte pas
    // l'utilisateur, on laisse juste l'erreur se propager
    return Promise.reject(error);
  }
);

export default axios;
